import {Component, Input, OnInit} from '@angular/core';
import {DataTableComponent} from "../DataTableComponent";
import {ActivatedRoute, Router} from "@angular/router";
import {BookingService} from "../../services/booking.service";
import {ConfirmationService} from "../../services/confirmation.service";
import {NbToastrService} from "@nebular/theme";
import {takeUntil} from "rxjs/operators";
import {SelectOption} from "../../models/select-option";
import {AuthService} from "../../services/auth.service";
import { GeneralUtils } from '../../utils/general.utils';

@Component({
    selector: 'app-booking-lite-table',
    templateUrl: './booking-lite-table.component.html',
    styleUrls: ['./booking-lite-table.component.scss']
})
export class BookingLiteTableComponent extends DataTableComponent implements OnInit {

    @Input() driver: string = null;
    @Input() rider: string = null;

    displayedColumns = [];

    filterStatuses: SelectOption<any>[] = [
        {label: '1. Cauta soferi', value: 'searchingDrivers'},
        {label: '2. Asteapta trimitere timp de la sofer catre client', value: 'pendingDriverToChooseTime'},
        {label: '3. Acceptat (soferul merge spre client)', value: 'accepted'},
        {label: '4. Soferul asteapta clientul', value: 'arrived'},
        {label: '5. In cursa', value: 'inTransit'},
        {label: '6. Asteptare suma sofer', value: 'endIntend'},
        {label: '7. Asteptare plata', value: 'waitForPayment'},
        {label: '8. Plata esuata', value: 'paymentFailed'},
        {label: '9. Finalizata', value: 'completed'},
        {label: 'Anulata', value: 'canceled'},
    ];


    filterPayedBy: SelectOption<any>[] = [
        {label: 'Cash', value: 'cash'},
        {label: 'Card', value: 'card'},
    ];
    filterMaxHoursBefore: SelectOption<any>[] = [
        {label: '24 ore', value: '24'},
        {label: '7 zile', value: '168'},    //7*24
        {label: '30 zile', value: '5040'},    //7*24*30
    ];

    constructor(
        protected bookingService: BookingService,
        private confirmationService: ConfirmationService,
        public authService: AuthService,
        toastr: NbToastrService,
        router: Router,
        route: ActivatedRoute
    ) {
        super(toastr, router, route, (params) => bookingService.getAllExtra(params, this.driver, this.rider));
    }

    ngOnInit() {
        super.ngOnInit();

        if(this.authService.userCan('bookings:details')) {
            this.displayedColumns = ['rider', 'driver', 'location', 'optionsInfo', 'prices', 'status', 'created'];
        } else {
            this.displayedColumns = ['driver', 'location', 'prices', 'created'];
        }

        this.bookingService.dataChanged$()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(() => {
                this.handleParamsChanged();
            });
    }

    /** Wraps GeneralUtils.isBookingUnpaid to avoid template access to potentially undefined static class. */
    isBookingUnpaid(row: any): boolean {
        return row != null && GeneralUtils.isBookingUnpaid(row);
    }

    setBookingCanceled(bookingId: any) {
        this.confirmationService.confirm({
            onSuccess: async () => {
                this.isLoading = true;
                await this.bookingService.cancelBooking(bookingId);
                this.isLoading = false;
                await this.toastr.show('toast.BookingCanceled', 'toast.BookingCanceledTitle');
            }
        });
    }


}
